/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import Header from './header';

import * as S from '../components/styles.css';
import './global-styling.module.css';

const isProd = process.env.NODE_ENV === 'production';

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
        allContentfulLayout {
          edges {
            node {
              id
              footer {
                childMarkdownRemark {
                  html
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet>
          <link rel="preconnect" href="https://fonts.gstatic.com" />
          <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;500&display=swap" rel="stylesheet" />

          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/default.min.css"
          />
          <script src="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/highlight.min.js" />
          <script src="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/languages/csharp.min.js" />
        </Helmet>

        {isProd && (
          <Helmet>
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-7L5LC1PZ5J"></script>
            <script>
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                  dataLayer.push(arguments);
                }
                gtag("js", new Date());
          
                gtag("config", "G-7L5LC1PZ5J");
              `}
            </script>
          </Helmet>
        )}

        <Header />
        <main className="content">{children}</main>

        <S.Footer>
          <S.FooterContent
            dangerouslySetInnerHTML={{ __html: data.allContentfulLayout.edges[0].node.footer.childMarkdownRemark.html }}
          />
        </S.Footer>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
